/*
 * Popup "Produto adicionado ao carrinho" — Ariel Malhas
 * Exibe o modal de confirmação quando um produto é adicionado ao carrinho
 * a partir de um formulário de produto (card da home ou página de produto).
 * Substitui a abertura automática do drawer (desativada no cart-drawer.liquid).
 */
import { StandardEvents } from '@shopify/events';

function getPopup() {
  return document.getElementById('ArielCartPopup');
}

function openPopup() {
  const dialog = getPopup();
  if (!dialog || dialog.open) return;
  if (typeof dialog.showModal === 'function') {
    dialog.showModal();
  } else {
    dialog.setAttribute('open', '');
  }
}

function closePopup() {
  const dialog = getPopup();
  if (dialog && dialog.open) dialog.close();
}

let openToken = 0;

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  // Só reage a adições vindas de um formulário de produto
  // (contexto 'product'), ignorando edições dentro do carrinho.
  if (event.action !== 'add') return;
  if (event.context && event.context !== 'product') return;

  // O evento é disparado de forma síncrona no envio do formulário, antes do
  // fetch. Abrimos o popup imediatamente (feedback instantâneo).
  openPopup();

  // Fechamento correlacionado a ESTE add: escutar o cartError global fechava o
  // popup em qualquer erro de carrinho (ex.: uma operação de quantidade no
  // drawer durante o refresh pós-add) — dando o "abre e fecha" intermitente
  // mesmo quando o item foi adicionado. Aqui só fechamos se a promise DESTE
  // add indicar falha (didError) ou rejeitar. Um add posterior invalida o
  // anterior via token, evitando que uma promise antiga feche um popup novo.
  const token = ++openToken;
  const promise = event.promise;
  if (promise && typeof promise.then === 'function') {
    promise
      .then((result) => {
        // Fecha SÓ se o próprio add reportou falha (didError). Não fechamos na
        // rejeição da promise: ela costuma significar que apenas o refresh do
        // carrinho falhou (o item já foi adicionado) — fechar aqui causava o
        // popup piscar em todo add. Melhor manter aberto.
        if (token === openToken && result && result.detail && result.detail.didError) {
          closePopup();
        }
      })
      .catch(() => {
        /* refresh/rede falhou — não fecha o popup (add provavelmente ocorreu) */
      });
  }
});

// Fecha ao clicar em "Continuar comprando" ou no X.
document.addEventListener('click', (event) => {
  if (!event.target.closest) return;
  if (event.target.closest('[data-acart-close]')) {
    event.preventDefault();
    closePopup();
  }
});

// Fecha ao clicar no backdrop (clique no próprio <dialog>).
document.addEventListener('click', (event) => {
  const dialog = getPopup();
  if (dialog && dialog.open && event.target === dialog) closePopup();
});
